<template>
  <div :class="{'field-custom':true, 'pts-widget':currentBrand === 'pts'}">
    <label class="field-label">{{ $t('common.mobile') }}</label>
    <form data-vv-scope="mobile-form" class="mobile-form" autocomplete="off">
      <div :class="{'intl-tel-input allow-dropdown margin-b-xs':true, 'field-error': errors.has('mobile-form.mobile'), 'disabled': showVericationForm, [dialCodeLength]:true}" @mouseleave="hideSubMenu = true;">

        <div class="flag-container" >
          <div class="selected-flag padding-a-s" @click="showSubMenu" :title="currentData.name + ': +' + currentData.dialCode">
            <div :class="'iti-flag ' + currentData.code"></div>
            <div class="iti-arrow"></div>
          </div>
          <div class="country-list-wrap">
            <ul class="country-list" v-show="!hideSubMenu">
              <li class="country-search">
                <input type="text" ref="inputMobileSearch" v-focus="!hideSubMenu" v-model="inputMobileSearch" />
              </li>
              <li class="search-space"></li>
              <li class="divider"></li>
              <li @click="currentCode = item.code;hideSubMenu = true;updateMobile()" v-for="item in frontCountriesArray" :class="'country ' + (item.code == currentCode ? 'highlight' : '')" v-show="isSearching">
                <div class="flag-box">
                  <div :class="'iti-flag ' + item.code"></div>
                </div>
                <span class="country-name">{{ item.name }}</span>
                <span class="dial-code">+{{ item.dialCode }}</span>
              </li>
              <li class="divider"></li>
              <li @click="currentCode = item.code;hideSubMenu = true;updateMobile()" v-for="item in countriesArray" :class="'country ' + (item.code == currentCode ? 'highlight' : '')" v-show="countryFilter(item.name)">
                <div class="flag-box">
                  <div :class="'iti-flag ' + item.code"></div>
                </div>
                <span class="country-name">{{ item.name }}</span>
                <span class="dial-code">+{{ item.dialCode }}</span>
              </li>
            </ul>
          </div>
        </div>

        <span class="dial-code-label">+{{ currentData.dialCode }}</span>

        <input type="mobile" name="mobile" :class="['form-control 1', {'disabled': disableField}]" :disabled="disableField" v-model="inputMobile" v-validate="'required|numeric'" data-vv-validate-on="none" @change="updateMobile" v-if="required" v-on:keypress="isNumber">
        <input type="mobile" name="mobile" :class="['form-control 2', {'disabled': disableField}]" :disabled="disableField" v-model="inputMobile" v-validate="'numeric'" data-vv-validate-on="none" @change="updateMobile" v-if="!required" v-on:keypress="isNumber">
        <span v-show="false">{{inputMobile}}-{{showVericationForm}}-{{resendReady}}</span>


        <div :class="{'field-button text-center':true, 'verified': mobileIsVerified, 'disabled': (errors.any('mobile-form') || this.inputMobile === '' || showVericationForm || !resendReady)}" v-if="needVerification">
          <div v-if="!getPinLoading" class='field-button-ie'>
            <a href="javascript:;" v-on:click="showHideForm" v-if="!mobileIsVerified">
              {{ $t('global.verify') }}
              <icon name="chevron-down" v-if="!showVericationForm"></icon>
              <icon name="chevron-up" v-if="showVericationForm"></icon>
            </a>
            <a href="javascript:;" v-if="mobileIsVerified">
              {{ $t('global.verified') }}
              <icon name="check" class="verified-icon"></icon>
            </a>
          </div>
          <div v-if="getPinLoading" class='field-button-ie'>
            <a>
              {{ $t('global.loading') }}
              <icon name="refresh" spin class="magin-l-s"></icon>
            </a>
          </div>
        </div>

        <span v-show="errors.has('mobile-form.mobile')" class="field-error-message">{{ errors.first('mobile-form.mobile') }}</span>
      </div>
    </form>

    <div v-show="!disableChangingPhone" class="f-right">
      <a href="javascript:;" class="change-phone" v-on:click="changePhoneNumber" v-if="mobileIsVerified">{{ $t('global.changePhone') }}</a>
    </div>

    <div v-bind:class="['mobile-verify-form showhide-fadeslide', ((showVericationForm && !mobileIsVerified)? '' : ' hide')]">
      <form v-bind:class="['padding-a-m', isSafari]" data-vv-scope="verify-form" v-on:submit.prevent="verifyPin()">
        <p class="margin-t-z">{{ $t('global.textPin') }}</p>
        <div class="medium-6 medium-offset-3 cell text-center">
          <div class="field-group margin-b-s">
            <div :class="{'field-combo':true, 'field-error': errors.first('verify-form.pin')}">
              <div class="field-button static left">
                <span class="padding-a-s">{{ $t('global.pin') }}</span>
              </div>
              <input type="text" name="pin" :class="{'field-text':true, 'disabled':pinVerificationLoading}" v-model="inputPin" :disabled="pinVerificationLoading" ref="pin" />
              <div class="field-button right">
                <button class="padding-a-s" type="submit" v-if="!pinVerificationLoading">{{ $t('global.verify') }}</button>
                <button class="padding-a-s" type="button" v-if="pinVerificationLoading">{{ $t('global.loading') }}</button>
              </div>
              <span v-show="errors.first('verify-form.pin')" class="field-error-message">{{ errors.first('verify-form.pin') }}</span>
            </div>
          </div>
          <div class="field-error-message2" v-show="needVerify && !errors.first('verify-form.pin')">{{$t('global.verifyFirst')}}</div>
          <a href="javascript:;" :class="['resend', {disabled: !resendReady}]" v-on:click="resendPin" v-show="!pinVerificationLoading">
            {{ $t('global.resendPin') }}
            <span v-if="resendCountdown > 0">({{ resendCountdown }} secs)</span>
            <icon name="refresh" spin class="magin-l-s" v-if="resendPinLoading"></icon>
          </a>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
const countries = require('@/data/countries')

Vue.use(VeeValidate)

export default (function () {
  return {
    props: {
      mobile: {
        default () { return []; }
      },
      isGuest: {
        default () { return []; }
      },
      needVerification: {
        default () { return []; }
      },
      required: {
        default () { return []; }
      },
      toFront: {
        type: Array,
        default () {
          return ['us', 'ca', 'gb'];
        }
      },
      countryCode: {
        type: String,
        default: Object.keys(countries)[225],
        validator (code) {
          var clearCode = String(code).toLowerCase();
          return !!countries[clearCode];
        }
      },
      dialCode: {
        default () {
          return [];
        }
      },
      checkUser: {
        default () { return false }
      }
    },
    data () {
      return {
        inputMobile: '',
        inputMobileSearch: null,
        inputPin: '',
        currentCode: this.countryCode,
        currentCodeLength: 0,
        hideSubMenu: true,
        showVericationForm: false,
        getPinLoading: false,
        needMobileVerification: true,
        mobileIsVerified: false,
        pinVerificationLoading: false,
        resendPinLoading: false,
        disableChangingPhone: false,
        dialCodeDefault: '',
        needVerify: false,
        isSafari: (navigator.userAgent.indexOf('Safari') !== -1 &&
          navigator.userAgent.indexOf('Chrome') === -1) ||
          navigator.userAgent.indexOf('Edge') > -1 ? 'safari' : ''
      }
    },
    computed: {
      currentBrand () { return this.$store.state.brandCode },
      currentData () {
        this.currentCodeLength = String(countries[this.currentCode].dialCode).length
        return countries[this.currentCode]
      },
      frontCountriesArray () {
        const toFrontCodes = {};

        this.toFront.forEach((code) => {
          const stringCode = String(code);
          const needObj = countries[stringCode];

          if (needObj) {
            toFrontCodes[stringCode] = needObj;
          }
        });

        return toFrontCodes;
      },
      countriesArray () {
        const countryCopie = {...countries};

        this.toFront.forEach((code) => {
          delete countryCopie[code];
        });

        return countryCopie;
      },
      dialCodeLength () {
        let lengthClass = ['', 'small', 'medium', 'large']
        return lengthClass[this.currentCodeLength - 1]
      },
      disableField () {
        if (!this.needVerification) { return false }
        if (this.mobileIsVerified || this.getPinLoading) { return true }
        if (this.mobile || this.showVericationForm) {
          this.needMobileVerification = false
          if (this.mobile) {
            this.mobileIsVerified = true
            this.$emit('verified', true)
          }
          return true
        } else if (!this.needMobileVerification) {
          return false
        }
        this.mobileIsVerified = false
      },
      disableVerifyBtn () {
        if (!this.inputMobile) {
          return true
        }
        return false
      },
      mobileValue () {
        this.inputMobile = this.mobile
        return this.mobile
      },
      isSearching () {
        return this.inputMobileSearch === '' || this.inputMobileSearch === null
      },
      isCorporate () { return this.$store.state.user.isCorporate },
      resendReady: {
        get () { return this.$store.state.user.resend.ready },
        set (x) { this.$store.commit('user/setResendReady', x) }
      },
      resendCountdown: {
        get () { return this.$store.state.user.resend.countdown },
        set (x) { this.$store.commit('user/setResendCountdown', x) }
      },
      user () { return this.$store.state.user },
      isLoggedIn () { return (this.user && this.user.firstName) || this.isCorporate }
    },
    methods: {
      showSubMenu: function () {
        if (this.disableField) return
        this.hideSubMenu = !this.hideSubMenu
        if (this.showVericationForm === true) {
          this.hideSubMenu = true;
        }
      },
      showHideForm: function () {
        let mobile = `${countries[this.currentCode].dialCode}${this.inputMobile}`
        let i = this.$store.state.other.verifiedMobile.indexOf(mobile)
        if (i > -1) {
          this.$emit('verified', true)
          this.showVericationForm = false
          this.mobileIsVerified = true
          this.pinVerificationLoading = false
          this.disableChangingPhone = false
          this.resendReady = false
          return
        }

        if (this.mobile && !this.needMobileVerification || !this.inputMobile || !this.needVerification) { return }
        this.mobileIsVerified = false
        if (!this.showVericationForm) {
          this.getPinLoading = true
          this.errors.remove('mobile-form.mobile')
          this.$root.$emit('getPin', {
            'phone': this.inputMobile,
            'countryCode': countries[this.currentCode].dialCode,
            isResend: true
          })
          return
        }
        this.showVericationForm = false
      },
      updateMobile: function () {
        if (this.inputMobile.match(/[^$,.\d]/)) {
          this.inputMobile = ''
          return
        }

        let _dialCode = countries[this.currentCode].dialCode
        let _mobile = this.inputMobile
        if (_mobile.indexOf(_dialCode) === 0) {
          _mobile = _mobile.substring(_dialCode)
        }
        this.$emit('updateMobile', {
          mobile: _mobile,
          countryCode: _dialCode
        })

        if (this.isCorporate) {
          this.$store.commit('user/setGuestPhone', this.inputMobile)
        } else if (!this.isGuest) {
          this.$store.commit('user/setUserPhone', {
            number: _mobile,
            code: _dialCode
          })
        }
      },
      changePhoneNumber: function () {
        this.needMobileVerification = true
        this.mobileIsVerified = false
        this.showVericationForm = false
        this.inputPin = ''
        this.errors.remove('verify-form.pin')
        this.$emit('verified', false)
        this.$emit('emptyPhone')
      },
      getCountryCodeByDialCode: function (val) {
        let keySelected = 'us'
        Object.keys(countries).map(function (key) {
          if (countries[key].dialCode === Number(val)) {
            keySelected = key
          }
        });
        return keySelected
      },
      countryFilter: function (val) {
        let countryName = val.toLowerCase()
        let regex = new RegExp(this.inputMobileSearch, 'gi')
        if (countryName.match(regex) || this.inputMobileSearch === null || this.inputMobileSearch === '') {
          return true
        } else {
          return false
        }
      },
      verifyPin: function () {
        if (this.getPinLoading) { return }
        this.needVerify = false
        this.errors.remove('verify-form.pin')
        if (this.inputPin.trim() === '') {
          this.errors.add('verify-form.pin', this.$t('global.fieldRequired'))
          return
        }
        this.$validator.validateAll('verify-form').then(result => {
          if (result) {
            this.pinVerificationLoading = true
            this.$root.$emit('verifyPin', {
              phone: this.inputMobile,
              countryCode: countries[this.currentCode].dialCode,
              smsCode: this.inputPin,
              checkUser: this.checkUser
            })
          }
        })
      },
      triggerValidate: function () {
        if (this.isCorporate && this.required) {
          this.$validator.validateAll('mobile-form').then(result => {
            if (result) {
              // this.$emit('guestMobileValidate', true)
            } else {
              // this.$emit('guestMobileValidate', false)
            }
          })
        }

        if (this.mobileIsVerified || !this.needVerification) {
          return
        }
        if (this.showVericationForm) {
          this.needVerify = true
          this.$emit('verified', false)
          this.$validator.validateAll('verify-form').then(result => {
          })
        } else {
          this.errors.add('mobile-form.mobile', this.$t('global.verifyFirst'));
        }
      },
      resendPin: function () {
        if (!this.resendReady) { return }
        this.inputPin = ''
        this.errors.remove('verify-form.pin')
        this.resendPinLoading = true
        this.$root.$emit('getPin', {
          'phone': this.inputMobile,
          'countryCode': countries[this.currentCode].dialCode,
          isResend: true
        })
      },
      reset: function () {
        this.mobileIsVerified = false
        var self = this
        setTimeout(function () {
          self.errors.items = []
        }, 50)
      },
      isNumber (evt) {
        let charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
          evt.preventDefault()
          return
        }
        return true
      }
    },
    watch: {
      mobile: function (val) {
        this.inputMobile = val
      },
      dialCodeDefault: function (val) {
        this.currentCode = val
        this.disableChangingPhone = true
      },
      dialCode: function (val) {
        if (val && this.dialCode) {
          this.currentCode = this.getCountryCodeByDialCode(val)
          this.disableChangingPhone = true
        }
      }
    },
    mounted: function () {
      let self = this
      this.$root.$on('getPinSuccess', ev => {
        if (!self.needVerification) { return }
        self.getPinLoading = false
        self.resendPinLoading = false
        self.showVericationForm = true
        self.$nextTick(function () {
          if (self.$refs.pin.focus() && !self.pinVerificationLoading) {
            self.$refs.pin.focus()
          }
        })
        if (ev.isResend) {
          self.resendReady = false
        }
      })
      this.$root.$on('getPinFail', ev => {
        if (!self.needVerification) { return }
        this.getPinLoading = false
        this.showVericationForm = false
        this.errors.add('mobile-form.mobile', this.$t('global.oops'))
      })
      this.$root.$on('mobileVerifySuccess', ev => {
        if (!this.needVerification) { return }
        this.$emit('verified', true)
        this.showVericationForm = false
        this.mobileIsVerified = true
        this.pinVerificationLoading = false
        this.disableChangingPhone = false
        this.resendReady = false
        let tmpMobile = `${countries[this.currentCode].dialCode}${this.inputMobile}`
        this.$store.commit('other/addVerifiedMobile', tmpMobile)
      })
      this.$root.$on('mobileVerifyFail', ev => {
        if (!this.needVerification) { return }
        this.pinVerificationLoading = false
        this.errors.add('verify-form.pin', this.$t('global.invalidPin'));
        this.$emit('verified', false)
      })

      let userPhone = this.$store.state.user.phone

      if (this.dialCode) {
        this.dialCodeDefault = this.getCountryCodeByDialCode(this.dialCode)
      } else if (this.$store.state.user.phone.code) {
        this.dialCodeDefault = this.$store.state.user.phone.code
      }

      if (userPhone.number && this.required) {
        this.inputMobile = userPhone.number
        this.dialCodeDefault = this.getCountryCodeByDialCode(userPhone.code)
      } else if (!this.required) {
        let guestInfo = this.$store.state.guestInfo
        this.inputMobile = guestInfo.mobile
        this.dialCodeDefault = this.getCountryCodeByDialCode(guestInfo.countryCode)
      }

      document.addEventListener("click", (evt) => {
        if (!self.hideSubMenu) {
          const flyoutEl = document.getElementById(self.uniqID)
          let targetEl = evt.target // clicked element
          do {
            if (targetEl === flyoutEl) {
              return
            }
            targetEl = targetEl.parentNode
          } while (targetEl)
          self.hideSubMenu = true
        }
      })
    }
  };
}());
</script>

<style lang="scss" scoped>
@import "../../assets/vendor/intlTelInput/css/intlTelInput.css";
@import "../../assets/scss/MobileInput.scss";

@media only screen and (max-width: 641px) {
  .pts-widget .verified-icon{ display: none; }
}

a.resend {
  &.disabled{
    cursor: default;
    color: #777!important;
  }
  span{
    display: inline-block;
    margin-left: 3px;
    color: #777!important
  }
}
.field-error-message2{
  font-size: 12px;
  background-color: #eb5837;
  color: #fff;
  padding: 3px 10px 5px;
  margin: 0;
  float: right;
}
</style>



// WEBPACK FOOTER //
// MobileInput.vue?b0e96e26